function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.925 8.066l-4.07 4.07c-.237.237-.549.355-.86.355-.312 0-.624-.118-.862-.356L2.69 8.692a1.219 1.219 0 010-1.722L6.76 2.9a.332.332 0 01.187-.093l3.287-.47a.332.332 0 01.282.094l.704.704-.939.94-.235-.235a.332.332 0 00-.47.47l.94.938a.33.33 0 00.47 0c.13-.13.13-.34 0-.47l-.235-.234.939-.94-.47-.469.705-.704a.332.332 0 01.47.47l-.705.704.704.704a.332.332 0 01.094.282l-.47 3.287a.332.332 0 01-.093.188zm-1.743-.548a.997.997 0 00-1.992 0 .997.997 0 001.992 0zm-4.753.996a.997.997 0 010-1.992.997.997 0 010 1.992zm.99 1.667a.332.332 0 00.42-.21l1.566-4.696a.332.332 0 00-.63-.21L6.21 9.76a.332.332 0 00.21.42zm7.182-3.73l-.595-.793-.33 2.313c-.03.212-.13.412-.282.564l-4.07 4.07a1.869 1.869 0 01-1.77.498c.216.338.595.563 1.026.563h4.87c.671 0 1.217-.546 1.217-1.217v-5.8a.332.332 0 00-.066-.199zM9.518 7.517a.332.332 0 11-.664 0 .332.332 0 01.664 0zm-4.089.332a.332.332 0 100-.664.332.332 0 000 .664z",
  fill: "#747474"
});

function SvgDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgDiscount;